import React, { memo } from "react";
import { Modal } from "react-bootstrap";

import { Button, Loading } from "../Components";
import { useSelector } from "react-redux";
import Icon from "../assets/icons/Icon";

const CommonModal = ({
  children,
  isShow,
  handleShowHide,
  modalTitle,
  isFooter = true,
  size = "lg",
  ...props
}) => {
  const { isLoading, isFormLoading } = useSelector((state) => state.ui);
  const handleSubmitClick = () => {
    const submiBtn = document.querySelector("#form-submit-btn");
    if (submiBtn && !isFormLoading) {
      submiBtn.click();
    }
  };

  const handleCustomClose = () => {
    const modal = document.getElementById("commonModal");
    modal.classList.remove("show");
    modal.removeAttribute("style");
  };

  return (
    <Modal
      show={isShow}
      onHide={handleShowHide}
      backdrop="static"
      keyboard={false}
      size={size || "lg"}
      centered
      className="market_order "
    >
      <Modal.Header>
        <Modal.Title>{modalTitle}</Modal.Title>
        <Icon
          name="X"
          onClick={handleShowHide}
          className="btn-close"
          style={{ cursor: "pointer" }}
        />
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {isFooter && (
        <Modal.Footer>
          {/* <Button className="btn-outline-danger" onClick={handleShowHide}>
            Close
          </Button>
          <Button
            className="btn-primary btn-md"
            onClick={handleSubmitClick}
            isDisabled={isFormLoading}
          >
            {!isFormLoading ? "Save Changes" : "Loading..."}
          </Button> */}

          <div className="row m-0 p-0 w-100 justify-content-end">
            <div className=" col-lg-7 col-9 m-0 p-1">
              <div className="form-group  ">
                <button
                  className="btn btn-success  p-2 w-100 "
                  type="submit"
                  onClick={handleSubmitClick}
                  isDisabled={isFormLoading}
                >
                  {!isFormLoading ? "Save Changes" : "Loading..."}
                </button>
                <button
                  className="btn btn-danger p-2 w-100 "
                  type="submit"
                  data-bs-dismiss="modal"
                  onClick={handleShowHide}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default memo(CommonModal);
